import { Button, Icon, Text } from '@chakra-ui/react'
import React from 'react'

import { useTabButtonStyle } from './componentStyles/TabButton.style'

type TabButtonProps = {
  isActive: boolean
  onClick: () => void
  text?: string
  leftIcon?: React.FunctionComponent<
    React.SVGProps<SVGSVGElement> & {
      title?: string | undefined
    }
  >
  rightIcon?: React.FunctionComponent<
    React.SVGProps<SVGSVGElement> & {
      title?: string | undefined
    }
  >
}
export const TabButton = ({
  isActive,
  onClick,
  text,
  leftIcon,
  rightIcon,
}: TabButtonProps) => {
  const styles = useTabButtonStyle()
  return (
    <Button sx={styles.button} isActive={isActive} onClick={onClick}>
      {leftIcon && <Icon as={leftIcon} sx={styles.icon} />}
      {text && <Text sx={styles.text}>{text}</Text>}
      {rightIcon && <Icon as={rightIcon} sx={styles.icon} />}
    </Button>
  )
}
